import { useMemo, useState } from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { buildNavigationForUser, findFirstAccessibleDocId } from '../../app/helpers/documentationWikiHelper';
import { isDocumentationWikiEnabled } from '../../app/helpers/documentationWikiConfigHelper';
import DocumentationViewer from './DocumentationViewer';
import DocsSidebar from './components/DocsSidebar';
import './documentation.css';

const DocumentationDocRoute = () => {
  const { docId } = useParams();
  return <DocumentationViewer docId={docId} />;
};

const DocumentationHub = () => {
  const { t } = useTranslation();
  const { roleLogin } = useSelector((state) => state.userRole);
  const configurationState = useSelector((state) => state.configuration);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const wikiEnabled = isDocumentationWikiEnabled(configurationState);

  const navigationTree = useMemo(
    () => buildNavigationForUser(roleLogin, configurationState),
    [roleLogin, configurationState],
  );

  const firstDocId = useMemo(
    () => findFirstAccessibleDocId(roleLogin, configurationState),
    [roleLogin, configurationState],
  );

  if (!wikiEnabled) {
    return (
      <Container className="docs-page-container">
        <Alert variant="warning">{t('docs.wikiDisabled')}</Alert>
      </Container>
    );
  }

  return (
    <Container fluid className="docs-page-container">
      <div className={`docs-layout ${sidebarCollapsed ? 'docs-layout--sidebar-collapsed' : ''}`}>
        {sidebarCollapsed && (
          <button
            type="button"
            className="docs-sidebar-expand-btn docs-no-print"
            onClick={() => setSidebarCollapsed(false)}
            title={t('docs.sidebarExpand')}
            aria-label={t('docs.sidebarExpand')}
          >
            <i className="fa fa-angle-double-right" />
          </button>
        )}

        <DocsSidebar
          navigationTree={navigationTree}
          roleLogin={roleLogin}
          configurationState={configurationState}
          collapsed={sidebarCollapsed}
          onToggleCollapse={() => setSidebarCollapsed(true)}
        />

        <main className="docs-main-panel">
          <Routes>
            <Route
              index
              element={
                firstDocId
                  ? <Navigate to={`/documentation/${firstDocId}`} replace />
                  : <Alert variant="info">{t('docs.emptyNavigation')}</Alert>
              }
            />
            <Route path=":docId" element={<DocumentationDocRoute />} />
          </Routes>
        </main>
      </div>
    </Container>
  );
};

export default DocumentationHub;
